import React from 'react';
import { styled } from 'linaria/react';
import NewsletterField from '../../Newsletter/NewsletterField';
import { cx } from 'linaria';
import { theme } from '../../Theme';
import MaxWidth from '../../Layout/MaxWidth';
import { htmlStyles } from './StartpageHtlm';

const ContainerWrapper = styled('div')`
  background-color: ${(props) => props.backgroundcolor};

  ${theme.below.lg} {
    background-color: transparent;
  }
`;

const StyledContainer = styled(MaxWidth)`
  padding: 0 10px;

  .startpage-newsletter-container {
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    padding: 72px 40px;
    text-align: center;
    background: ${(props) => props.backgroundcolor};

    ${theme.below.md} {
      padding: 40px 20px;
    }

    .startpage-newsletter-html {
      max-width: 550px;
      margin: 0 auto;
      margin-bottom: 32px;
    }
    div form > * {
      border-radius: 20px;
      overflow: hidden;
      input {
        border-radius: 20px;
      }
    }

    .newsletter-field-wrapper {
      form {
        flex-direction: column;
        align-items: center;
        justify-content: center;

        button {
          flex: unset;
          text-transform: uppercase;
          color: ${(props) => props.buttontextcolor};
          background: ${(props) => props.buttonbackgroundcolor};
          font-weight: ${(props) => props.fontweight ?? '700'};
        }

        > * {
          width: 100%;
          max-width: 380px;
          margin-bottom: 16px;
        }
      }
    }
  }
`;

export const StartPageNewsletter = ({
  html,
  backgroundColor,
  buttonTextColor,
  buttonTextFontWeight,
  buttonBackgroundColor,
}) => {
  return (
    <ContainerWrapper backgroundcolor={backgroundColor?.value ?? '#f3f3f3'}>
      <StyledContainer
        backgroundcolor={backgroundColor?.value ?? '#f3f3f3'}
        buttontextcolor={buttonTextColor?.value ?? '#fff'}
        buttonbackgroundcolor={buttonBackgroundColor?.value ?? '#000'}
        fontweight={buttonTextFontWeight?.value ?? '700'}
      >
        <div className="startpage-newsletter-container">
          <div
            className={cx('startpage-newsletter-html', htmlStyles)}
            dangerouslySetInnerHTML={{ __html: html?.value }}
          />
          <NewsletterField />
        </div>
      </StyledContainer>
    </ContainerWrapper>
  );
};
